module.exports = __webpack_public_path__ + "img/mb-pgk-bg.6534fd34.png";